var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"subs-header"},[_c('h1',{staticClass:"subs-title center"},[_vm._v("Want delete Kangaroo Account?")])])
}]

export { render, staticRenderFns }